export function getAnalyticUniqueId(key = 'GA_UUID'): string {
  if (localStorage.getItem(key)) {
    return localStorage.getItem(key) as string;
  }
  const newId = `${Math.floor(Math.random() * Date.now())}-${Math.floor(Math.random() * Date.now())}`;
  localStorage.setItem(key, newId);
  return newId;
}
